.container {
  position: relative;
  display: flex;
  flex-direction: column;
}

.input {
  position: relative;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  font-size: 1.6rem;
  letter-spacing: 0.3px;
  line-height: 2rem;
  resize: none;
  padding: 0.6rem 0.8rem;
  background-color: transparent;
  color: var(--white-default);
  border-radius: var(--border-radius-medium);
  border: 0.1rem solid transparent;

  &:focus {
    background-color: transparent !important;
    border-color: var(--color-secondary);
  }

  &:hover {
    background-color: #ffffff11;
    cursor: text;
  }

  &[data-error='true'] {
    &:focus {
      border-color: var(--color-error);
    }
  }
}

.error {
  position: absolute;
  right: 0;
  bottom: -2.4rem;
  height: 1.6rem;
  color: var(--color-error);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: -0.2px;
  line-height: 1.6rem;
  text-align: right;
}
